export default {
	events: {
		widgetUserEvent: [
			{
				logic: {
					'eventData.widgetName': 'ws-site-text-search',
					'eventData.action': 'impression'
				},
				payload: ({ eventData: { pageSearchResultsCount } }) => {
					return {
						nrPageAction:
							'ws-site-text-search_page-search-results_count',
						nrData: {
							count: pageSearchResultsCount
						}
					};
				}
			}
		]
	}
};
